class SessionService {
  static isFull(session: Dto.Session) {
    return session.confirmed_bookings >= session.member_limit
  }
}

export { SessionService }
